import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Tabs from '~/components/header/tabs';
import PostTitle from '~/components/header/post-title';

// If in post editor screen
if (
	document.location.href.includes( 'post.php' ) ||
	document.location.href.includes( 'post-new.php' )
) {
	// Hook into Guteberg Middleware
	wp.apiFetch &&
		wp.apiFetch.use( ( options, next ) => {
			// Getting the course_id value from query params using regular expressions
			const re = new RegExp( '([?&])course_id=.*?(&|$)', 'i' );
			const uri = window.location.href;
			const match = uri.match( re );
			const course_id = match && match[ 0 ] && match[ 0 ].substring( 11 );
			if ( course_id && options && options.data ) {
				// Pass course_id to POST data
				options.data.course_id = course_id;
			}
			const result = next( options );
			return result;
		} );
}

/**
 * Display top level header on the page.
 *
 * @param {Object} props
 * @param {string} props.el
 */
const GlobalHeader = ( { el } ) => {
	if ( document.getElementById( el ) ) {
		let post_type = null;

		if ( LearnDashData.post_data ) {
			post_type = LearnDashData.post_data.builder_post_type;
		}

		let url = `${ LearnDashData.adminurl }?post_type=${ post_type }`;
		let title = `${ LearnDashData.i18n.back_to } ${ LearnDashData.labels[ post_type ] }`;

		if ( LearnDashData.back_to_title ) {
			title = LearnDashData.back_to_title;
		}

		if ( LearnDashData.back_to_url ) {
			url = LearnDashData.back_to_url;
		}

		return ReactDOM.createPortal(
			<div className="ld-global-header edit-post-header">
				{ LearnDashData.post_data && (
					<div>
						{ LearnDashData.back_to_title &&
							LearnDashData.back_to_url && (
								<a href={ url } className="ld-back-link">
									&larr; { title }
								</a>
							) }
						<PostTitle />
					</div>
				) }
				<Tabs />
			</div>,
			document.getElementById( el )
		);
	}
	return null;
};

/**
 * Valid props
 */
GlobalHeader.propTypes = {
	el: PropTypes.string,
};

export default GlobalHeader;
